import { toastr } from "react-redux-toastr";
import { CATEGORIES_ACTION_TYPES } from "./actionTypes";
import { categoriesApi } from "./api";

export const categoriesActions = {
    fetchListRequest: (filters) => ({
        type: CATEGORIES_ACTION_TYPES.FETCH_LIST_REQUEST,
        payload: { filters },
    }),
    fetchListSuccess: (data) => ({
        type: CATEGORIES_ACTION_TYPES.FETCH_LIST_SUCCESS,
        payload: { data },
        meta: { timestamp: Date.now() },
    }),
    fetchListFailure: (error) => ({
        type: CATEGORIES_ACTION_TYPES.FETCH_LIST_FAILURE,
        payload: { error },
        error: true,
    })
}

export const fetchSubcategories = (parentId) => {
    return async (dispatch) => {
        dispatch({ type: CATEGORIES_ACTION_TYPES.FETCH_SUBCATEGORIES_REQUEST, payload: { parentId } });

        try {
            const data = await categoriesApi.fetchSubcategories(parentId);
            dispatch({
                type: CATEGORIES_ACTION_TYPES.FETCH_SUBCATEGORIES_SUCCESS,
                payload: { parentId, data },
            });
        } catch (error) {
            console.error('Subcategories fetch error:', error);
            dispatch({
                type: CATEGORIES_ACTION_TYPES.FETCH_SUBCATEGORIES_FAILURE,
                payload: { parentId, error: error.message },
            });
        }
    };
};

export const fetchCategoriesList = (options = {}) => {
    return async (dispatch, getState) => {
        const { refresh = false, filters = {} } = options;
        const state = getState().categories;

        if (state.loading.list && !refresh) {
            return;
        }

        const currentFilters = {
            ...state.filters,
            ...filters,
        }

        dispatch(categoriesActions.fetchListRequest(currentFilters));

        try {
            const result = await categoriesApi.fetchList(currentFilters);

            dispatch(categoriesActions.fetchListSuccess(result.data));
        } catch (error) {
            console.error('Categories fetch error:', error);
            dispatch(categoriesActions.fetchListFailure(error.message));
            toastr.error('Ошибка', `Не удалось загрузить категории: ${error.message}`);
        }
    }
}